import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';

import type { StorageClassListResponse } from './types';

/** 全局存储类列表（dc/ws 由 URL 解析） */
export function getStorageClasses(params?: Record<string, unknown>): Promise<StorageClassListResponse> {
  return get(`${PREFIX.vapis_v1_dc_ws(GROUPS.storageStack)}/all-storages`, { limit: -1, ...params });
}
